import { v4 as uuidv4 } from 'uuid';

export const getOidcParams = () => {
  const params       = new URLSearchParams(window.location.search);
  return {
    code:           params.get('code'),
    state:          params.get('state'),
    codeVerifier:   localStorage.getItem('pkce_code_verifier'),
    expectedState:  localStorage.getItem('pkce_state'),
    configId:       localStorage.getItem('pkce_config_id'),
    provider:       localStorage.getItem('pkce_provider'),
  };
}

export const generateCodeVerifier = () => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return Array.from(array)
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}

export const generateCodeChallenge = async (verifier) => {
  const buffer = new TextEncoder().encode(verifier);
  const digest = await window.crypto.subtle.digest('SHA-256', buffer);
  const base64 = btoa(String.fromCharCode(...new Uint8Array(digest)));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export const storePkceParams = ({ verifier, state, configId, provider }) =>{
  localStorage.setItem('pkce_code_verifier', verifier);
  localStorage.setItem('pkce_state', state);
  localStorage.setItem('pkce_config_id', configId);
  localStorage.setItem('pkce_provider', provider);
}

/**
 * Begin an SP-initiated authorization-code + PKCE login against one configured
 * provider. Shared by the provider dropdown and by a single-provider button, so
 * both take exactly the same route.
 */
export const startOidcLogin = async (config, apiBaseUrl) => {
  if (!config) return;

  const codeVerifier = generateCodeVerifier();
  const state = uuidv4();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  storePkceParams({
    verifier: codeVerifier,
    state,
    configId: config.id,
    provider: config.provider
  });

  window.location.href = `${apiBaseUrl}/api/openid/auth/${config.provider}` +
    `?configId=${config.id}` +
    `&code_challenge=${encodeURIComponent(codeChallenge)}` +
    `&state=${state}`;
}